
<div *ngIf="isIconRegistered" class="stored-icon" [ngStyle]="getIconStyle()"></div>
<div *ngIf="!isIconRegistered" class="drawn-icon" [ngStyle]="getIconStyle()">
	<div class="first-letter-icon">{{ firstLetter }}</div>
</div>
